var definitionList = 'definitionList_definitionList__14nggi00';

export { definitionList };
//# sourceMappingURL=definitionList.vanilla.mjs.map
